import { atom } from 'recoil'

export const deviceSize = atom({
  key: 'deviceSize',
  default: 0,
})

export const windowSize = atom({
  key: 'windowSize',
  default: {
    width:
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth,
    height:
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight,
  },
})

export const selectedClients = atom({
  key: 'selectedClients',
  default: 0,
})

export const showService = atom({
  key: 'showService',
  default: false,
})

export const selectedService = atom({
  key: 'selectedService',
  default: -1,
})

export const showMember = atom({
  key: 'showMember',
  default: false,
})

export const selectedMember = atom({
  key: 'selectedMember',
  default: -1,
})

export const selectedClient = atom({
  key: 'selectedClient',
  default: '',
})

export const selectedAward = atom({
  key: 'selectedAward',
  default: '',
})

export const currentSection = atom({
  key: 'currentSection',
  default: window.laborgg.data.not_found ? 'not-found' : 'intro',
})

export const currentFix = atom({
  key: 'currentFix',
  default: 'quienes-somos',
})

export const lastSection = atom({
  key: 'lastSection',
  default: 'intro',
})

export const toggleMenu = atom({
  key: 'toggleMenu',
  default: false,
})
